export const AUTH_TYPE = {
  MASTER: 'master',
  MEMBER: 'member',
  GUEST: 'guest',
  ANONYMOUS: 'anonymous',
} as const;

export type AUTH_TYPE_KEY = keyof typeof AUTH_TYPE;

export type AUTH_TYPE_VALUE = typeof AUTH_TYPE[AUTH_TYPE_KEY];

export const AUTH_TYPE_MAP = {
  [AUTH_TYPE.MASTER]: '관리자',
  [AUTH_TYPE.MEMBER]: '멤버',
  [AUTH_TYPE.GUEST]: '손님',
  [AUTH_TYPE.ANONYMOUS]: '익명',
};

export const selectedAuthList = [
  {
    key: AUTH_TYPE.MASTER,
    value: '관리자',
    description: '모든 게시글 편집 가능',
  },
  {
    key: AUTH_TYPE.MEMBER,
    value: '멤버',
    description: '게시글, 댓글 쓰기 가능',
  },
  {
    key: AUTH_TYPE.GUEST,
    value: '손님',
    description: '읽기만 가능',
  },
];
